module.exports = __webpack_public_path__ + "static/img/8.3d112e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/4/1/zh/8.png
// module id = zplB
// module chunks = 0